const COOKIE_PREFIX = 'dot_pad_skipped_firmware_'

function versionParts(version) {
    if (/^v[0-9a-f]+(?:\.[0-9a-f]+)*$/i.test(version)) {
        return version.slice(1).split('.').map(part => parseInt(part, 16))
    }
    if (/^\d+(?:\.\d+)*$/.test(version)) {
        return version.split('.').map(Number)
    }
    return null
}

function compareVersions(left, right) {
    const leftParts = versionParts(left)
    const rightParts = versionParts(right)
    if (!leftParts || !rightParts) return null
    for (let i = 0; i < Math.max(leftParts.length, rightParts.length); i++) {
        const difference = (leftParts[i] || 0) - (rightParts[i] || 0)
        if (difference) return Math.sign(difference)
    }
    return 0
}

export function isNewerFirmwareVersion(latest, current) {
    if (!latest || !current) return false
    const comparison = compareVersions(latest, current)
    return comparison === null ? latest > current : comparison > 0
}

export function isFirmwareVersionSkipped(cookies, deviceModel, version, phase = 'version-check') {
    if (!deviceModel || !version) return false
    const cookieKey = COOKIE_PREFIX + deviceModel
    try {
        const skipped = cookies?.get(cookieKey)
        const validCookie = typeof skipped === 'string'
        const comparison = validCookie ? compareVersions(version, skipped) : null
        const shouldSkip = validCookie && (skipped === version || (comparison !== null && comparison <= 0))
        console.log('[DotPad][firmware][cookie-check]', JSON.stringify({
            phase, deviceModel, cookieKey, checkedVersion: version,
            skippedVersion: validCookie ? skipped : null,
            shouldSkip,
            reason: !validCookie ? '저장된 건너뛰기 버전 없음'
                : shouldSkip ? '쿠키에 저장된 버전 이하이므로 안내 생략 대상'
                    : '저장된 버전보다 높거나 다른 버전이므로 안내 생략 안 함'
        }))
        return shouldSkip
    } catch {
        console.warn('[DotPad][firmware][cookie-check]', JSON.stringify({phase, deviceModel, cookieKey, checkedVersion: version, shouldSkip: false, reason: '쿠키 읽기 실패'}))
        return false
    }
}

export function skipFirmwareVersion(cookies, deviceModel, version) {
    if (!deviceModel || typeof version !== 'string' || !version) return false
    try {
        const key = COOKIE_PREFIX + deviceModel
        cookies.set(key, version, -1, '/', undefined, undefined, 'Lax')
        const storedVersion = cookies.get(key)
        const saved = storedVersion === version
        console.log('[DotPad][firmware][cookie-save]', JSON.stringify({deviceModel, cookieKey: key, requestedVersion: version, storedVersion, saved}))
        return saved
    } catch {
        console.warn('[DotPad][firmware][cookie-save]', JSON.stringify({deviceModel, cookieKey: COOKIE_PREFIX + deviceModel, requestedVersion: version, saved: false, reason: '쿠키 저장 실패'}))
        return false
    }
}

export function clearSkippedFirmwareVersion(cookies, deviceModel) {
    if (!deviceModel) return false
    try {
        const key = COOKIE_PREFIX + deviceModel
        cookies.remove(key, '/')
        const cleared = cookies.get(key) == null
        console.log('[DotPad][firmware][cookie-clear]', JSON.stringify({deviceModel, cookieKey: key, cleared}))
        return cleared
    } catch {
        console.warn('[DotPad][firmware][cookie-clear]', JSON.stringify({deviceModel, cookieKey: COOKIE_PREFIX + deviceModel, cleared: false, reason: '쿠키 삭제 실패'}))
        return false
    }
}

export function clearSkippedFirmwareVersions(cookies, deviceModel) {
    if (deviceModel) return clearSkippedFirmwareVersion(cookies, deviceModel)
    try {
        let cleared = true
        for (const key of cookies.keys().filter(key => key.startsWith(COOKIE_PREFIX))) {
            if (!clearSkippedFirmwareVersion(cookies, key.slice(COOKIE_PREFIX.length))) cleared = false
        }
        return cleared
    } catch {
        return false
    }
}
